<template>
    <div v-if="!config.modules.catalog_mode">
        <a v-if="dataProduct.variations.length" :href="dataProduct.url" class="btn btn-sm btn-secondary"><i class="fas fa-tasks fa-fw"></i> {{ t.product.select_options }}</a>
        <div v-else>
            <button :disabled="!canOrder" class="btn btn-sm btn-primary" @click="addToCart"><i class="fas fa-shopping-bag fa-fw"></i> {{ t.product.add_to_cart }}</button>
            <a v-if="config.modules.buy_now && canOrder" class="btn btn-sm btn-secondary" :href="dataProduct.buyNow">{{ t.product.buy_now }}</a>
        </div>
    </div>
</template>

<script>
    import store from "../CartStore";
    export default {
        props: ['dataProduct'],
        store: store,
        data() {
            return {
                t: t,
                config: config,
                settings: settings,
            };
        },
        computed: {
            canOrder() {
                if (config.modules.stock && !settings.order_out_of_stock && this.dataProduct.stock <= 0) {
                    return false
                }
                return true
            },
        },
        methods: {
            ...Vuex.mapActions(['addProduct']),
            addToCart() {
                this.dataProduct.qty = 1
                this.addProduct(this.dataProduct);
            },
        },
    }
</script>
